import React, { useEffect, useState } from "react";
import canaisService from "../../services/CanaisService";
import { useNavigate } from "react-router-dom";
import { url } from "inspector";

const CategoryList = (props: any) => {
  const { channelId, search } = props;
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getCanais();
  }, [channelId, search]);

  const getCanais = async () => {
    setLoading(true); // start loading
    await canaisService
      .getCanais(channelId, search)
      .then((response: any) => {
        console.log("categorias: ", response);
        setCategorias(response.categories);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const montarUrl = (categoryId: any) => {
    if (channelId === 1) return "/dicas/" + categoryId;
  };

  const exibirCategorias = () => {
    return categorias.map((categoria: any) => {
      const urlBase: any =
        process.env.REACT_APP_BACKEND_API_URL +
        "/storage/images/categories/banners";
      const backgroundImageUrl: any = urlBase + `/${categoria.banner_path}`;
      return (
        <div style={{ padding: "0.4rem" }}>
          <div
            onClick={() => {
              const url = montarUrl(categoria.id);
              if (url) {
                navigate(url);
              }
            }}
            style={{ backgroundImage: `url(${backgroundImageUrl})` }}
            className={`flex justify-center cursor-pointer w-[150px] h-[100px] bg-cover rounded-3xl`}
          >
            <span className="flex bg-primary-900 bg-opacity-60 items-center h-full w-full justify-center text-center px-10 font-semibold brightness-100 text-white rounded-3xl">
              {categoria.name}
            </span>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flexCard mt-5 justify-content-center">
      {loading ? (
        <div className="spinner border-primary-600"></div>
      ) : categorias.length > 0 ? (
        exibirCategorias()
      ) : (
        <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
          Nenhum resultado encontrado
        </div>
      )}
    </div>
  );
};

export default CategoryList;
